<template>
    <div class="btn" @click="toggleFull">
        <span>全屏</span>
        <i class="el-icon-full-screen sty"></i>
    </div>
</template>

<script>
//vue判断是否是全屏的插件 screenfull
import screenfull from 'screenfull';
export default {
    methods:{
        toggleFull(){
            
            //判断当前浏览器是否可全屏
            if(!screenfull.isEnabled){
                this.$message({
                    type:'warning',
                    message:'当前不可全屏'
                })
                return false
            }
            screenfull.toggle();
        }
    }
}
</script>

<style lang='scss' scoped>
    .btn{
        cursor: pointer;
    }
    .sty{
        padding-left: 5px;
        font-size: 18px;
    }
</style>